import React from 'react';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import Reels from 'bdvp-reel/src/containers/Reels';

import Menu from '../../containers/Menu';
import SearchButton from '../../containers/SearchButton';
import Branding from '../Branding';

import BaseSubnav, {
    BaseMenuReels,
    BaseMenuWrapper,
    BaseSearchButtonWrapper,
    BaseBrandingWrapper
} from './BaseSubnav';

const Navbar = styled(BaseSubnav)`
    ${media.mdmin`
        padding: 0px 1px;
        grid-template-areas: 'search branding menureels';
        grid-template-columns: 1fr 1fr 1fr;
    `}
    ${media.lgmin`
        padding: 0 22px;
    `}
`;

const BrandingWrapper = styled(BaseBrandingWrapper)`
    ${media.mdmin`
        justify-self: center;
    `}
`;

const SearchButtonWrapper = styled(BaseSearchButtonWrapper)`
    ${media.mdmin`
        justify-self: flex-start;
    `}
`;

const FilterSearchSubnav = () => {

    return (
        <Navbar>
            <BrandingWrapper>
                <Branding />
            </BrandingWrapper>
            <SearchButtonWrapper>
                <SearchButton />
            </SearchButtonWrapper>
            <BaseMenuReels>
                <BaseMenuWrapper>
                    <Menu />
                </BaseMenuWrapper>
                <Reels />
            </BaseMenuReels>
        </Navbar>
    );

};

export default FilterSearchSubnav;
